import React, { useCallback } from 'react';

import Accordion from 'components/Accordion';
import Checkbox from 'components/DesignSystem/Checkbox';
import Snackbar from 'components/DesignSystem/Snackbar';
import useMembers from 'hooks/Meteorology/Fields/TrackingForecast/DetailedView/useMembers';

export default function Members() {
  const { members, selectedMembers, setSelectedMembers } = useMembers();
  const setMembers = useCallback((newMember: number) => {
    const index = selectedMembers.findIndex((member) => newMember === member);
    if (index === -1) {
      setSelectedMembers([...selectedMembers, newMember]);
    } else {
      const newMembers = [...selectedMembers];
      newMembers.splice(index, 1);
      setSelectedMembers(newMembers);
    }
  }, [selectedMembers, setSelectedMembers]);

  return (
    <Accordion.Item eventKey="members" id="members-accordion">
      <Accordion.Header>Membros</Accordion.Header>
      <Accordion.Body>
        {members.length === 0 && (
          <Snackbar>Nenhum membro disponível para os parâmetros selecionados.</Snackbar>
        )}
        {members.map((member) => (
          <Checkbox
            key={member.id}
            label={member.label}
            checked={selectedMembers.includes(member.id)}
            onChange={() => setMembers(member.id)}
            className="my-2"
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
